import React, { useState } from "react";
import remove from "lodash/remove";

import { PartnerPageContext } from "../contexts/partnerPageContext";
import { useEventListener } from "../hooks/useEventListener";
import { EVENT_TOPICS } from "../utilities/eventUtils";

const PartnerPageContextProvider = ({ children }) => {
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState();
  const [totalPages, setTotalPages] = useState();
  const [partners, setPartners] = useState();
  const [singlePartner, setSinglePartner] = useState();

  useEventListener(
    EVENT_TOPICS.ON_PARTNER_DELETED,
    ({ deletedPartnerId }) => {
      const copiedData = [...partners];
      remove(copiedData, (item) => item.id === deletedPartnerId);

      setPartners(copiedData);
    },
    [partners]
  );

  useEventListener(
    EVENT_TOPICS.ON_PARTNER_UPDATED,
    ({ updatedPartner }) => {
      setSinglePartner((prev) => ({ ...prev, ...updatedPartner }));
    },
    [singlePartner]
  );

  return (
    <PartnerPageContext.Provider
      value={{
        partners,
        setPartners,
        singlePartner,
        setSinglePartner,
        currentPage,
        setCurrentPage,
        totalPages,
        setTotalPages,
        totalRecords,
        setTotalRecords,
        pageSize,
        setPageSize,
      }}
    >
      {children}
    </PartnerPageContext.Provider>
  );
};

export default PartnerPageContextProvider;
